<div class="min-h-screen bg-slate-50 flex justify-center pb-20">
  <div class="w-full max-w-md bg-white min-h-screen sm:min-h-[calc(100vh-2rem)] sm:mt-8 sm:rounded-3xl sm:shadow-2xl sm:border border-slate-200 overflow-hidden relative flex flex-col">
    <!-- Header -->
    <div class="sticky top-0 z-20 bg-white/80 backdrop-blur-md border-b border-slate-100 shadow-sm">
      @if (theme.coverUrl(); as cover) {
      <img [src]="cover" [alt]="theme.name()" class="w-full h-32 object-cover" />
      }
      <div class="flex items-center gap-4 px-5 py-4">
        @if (theme.logoUrl(); as logo) {
        <img [src]="logo" [alt]="theme.name()"
          class="w-12 h-12 rounded-2xl object-contain bg-white border border-slate-100 shadow-sm shrink-0"
          [class.-mt-10]="theme.coverUrl()" />
        }
        <!-- <button
          class="h-10 w-10 grid place-items-center rounded-2xl bg-white border border-slate-100 shadow-sm hover:bg-slate-50 hover:shadow-md active:scale-95 transition-all"
          (click)="toBack()">
          <span class="material-symbols-outlined text-slate-700">arrow_back</span>
        </button> -->
        <div class="flex-1">
          <h1 class="text-xl font-black text-slate-800 tracking-tight">{{ 'เลือกที่พัก' | translate : 'list-location' }}</h1>
          <p class="text-xs font-medium text-slate-500 mt-0.5">
            @if (theme.name()) {<span class="font-bold text-blue-600">{{ theme.name() }}</span> · }
            {{ 'ค้นหาหรือเลือกสาขาที่คุณต้องการ' | translate : 'list-location' }}
          </p>
        </div>
        <app-language-switcher />
      </div>

      <!-- Search -->
      <div class="px-5 pb-4">
        <div class="relative group">
          <div class="absolute inset-y-0 left-4 flex items-center pointer-events-none">
            <span class="material-symbols-outlined text-slate-400 group-focus-within:text-blue-500 transition-colors" style="font-size:1.25rem">
              search
            </span>
          </div>
          <input
            type="text"
            [value]="searchQuery()"
            (input)="searchQuery.set($any($event.target).value)"
            [placeholder]="'ค้นหาชื่อที่พัก...' | translate : 'list-location'"
            class="w-full bg-slate-50/50 border border-slate-200 text-slate-800 text-sm rounded-2xl focus:ring-4 focus:ring-blue-500/10 focus:border-blue-500 block w-full pl-11 p-3.5 transition-all placeholder:text-slate-400 outline-none"
          />
        </div>
      </div>
    </div>

    <div class="flex-1 overflow-y-auto w-full">
      <!-- Loading Skeleton -->
      @if (loadingBranch()) {
        <div class="p-5 space-y-4 animate-pulse">
          @for (i of [1,2,3,4,5]; track i) {
            <div class="bg-white rounded-3xl p-4 flex items-center gap-4 border border-slate-100 shadow-sm">
              <div class="w-14 h-14 rounded-2xl bg-slate-200 shrink-0"></div>
              <div class="flex-1 space-y-2.5">
                <div class="h-4 bg-slate-200 rounded-lg w-3/4"></div>
                <div class="h-3 bg-slate-100 rounded-lg w-1/2"></div>
              </div>
              <div class="w-8 h-8 rounded-xl bg-slate-100 shrink-0"></div>
            </div>
          }
        </div>

      } @else if (filteredItems().length === 0) {
        <!-- Empty state -->
        <div class="flex flex-col items-center justify-center p-10 mt-10 text-center">
          <div class="w-24 h-24 rounded-full bg-slate-50 flex items-center justify-center mb-6 shadow-inner border border-slate-100">
            <span class="material-symbols-outlined text-slate-300" style="font-size:3rem">location_off</span>
          </div>
          <h3 class="text-lg font-bold text-slate-800 mb-2">{{ 'ไม่พบที่พักที่คุณค้นหา' | translate : 'list-location' }}</h3>
          <p class="text-sm text-slate-500 max-w-[200px]">{{ 'ลองใช้คำค้นหาอื่นๆ หรือตรวจสอบการสะกดคำอีกครั้ง' | translate : 'list-location' }}</p>
        </div>

      } @else {
        <!-- List -->
        <div class="p-4 space-y-4">
          @for (item of filteredItems(); track $index) {
            <button
              class="w-full text-left bg-white rounded-3xl border border-slate-100 overflow-hidden shadow-[0_4px_20px_rgba(0,0,0,0.04)] hover:shadow-[0_8px_30px_rgba(0,0,0,0.1)] hover:-translate-y-0.5 active:scale-[0.98] transition-all group/item"
              (click)="selectBranch(item)">

              <!-- Image + Overlay -->
              <div class="relative w-full aspect-[16/8] overflow-hidden bg-slate-100">
                @if (item.detail?.images?.[0]?.imagePath) {
                  <img [src]="imgURL + item.detail.images[0].imagePath" [alt]="item.name"
                    (error)="$any($event.target).src='no-image.svg'"
                    class="w-full h-full object-cover group-hover/item:scale-105 transition-transform duration-500" />
                } @else {
                  <img src="no-image.svg" [alt]="item.name"
                    class="w-full h-full object-cover" />
                }
                <div class="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>

                <!-- Badge typeName top-left -->
                @if (item.typeName) {
                <div class="absolute top-3 left-3 flex items-center gap-1 bg-white/20 backdrop-blur-md border border-white/30 rounded-full px-2.5 py-1">
                  <span class="material-symbols-outlined text-white" style="font-size:0.85rem">hotel</span>
                  <span class="text-[11px] font-bold text-white">{{item.typeName}}</span>
                </div>
                }

                <!-- Arrow top-right -->
                <div class="absolute top-3 right-3 w-8 h-8 rounded-full bg-white/20 backdrop-blur-md border border-white/30 flex items-center justify-center group-hover/item:bg-blue-500 group-hover/item:border-blue-500 transition-all">
                  <span class="material-symbols-outlined text-white" style="font-size:1.1rem">chevron_right</span>
                </div>

                <!-- Name + Address bottom-left -->
                <div class="absolute bottom-0 left-0 right-0 p-4">
                  <div class="text-[16px] font-black text-white leading-snug tracking-tight drop-shadow">{{item.name}}</div>
                  @if (item.detail?.address || item.detail?.district || item.detail?.province) {
                  <div class="mt-1 flex items-center gap-1 text-[12px] text-white/80 font-medium">
                    <span class="material-symbols-outlined text-white/60 shrink-0" style="font-size:0.9rem">location_on</span>
                    <span class="line-clamp-1">{{item.detail?.address}}{{item.detail?.district ? ' ' + item.detail.district : ''}}{{item.detail?.province ? ' ' + item.detail.province : ''}}</span>
                  </div>
                  }
                </div>
              </div>

            </button>
          }
        </div>
      }
    </div>
  </div>
</div>
